// src/pages/WorkerForgotPassword.js
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import bynLogo from "./byn-logo.jpeg";

const API_WRK = process.env.REACT_APP_API_WRK;

const WorkerForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSendOTP = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!email.trim()) {
      setMessage("Please enter your email.");
      return;
    }

    try {
      await axios.post(`${API_WRK}/send-reset-otp`, { email });
      localStorage.setItem("workerResetEmail", email);
      setMessage("Verification code sent to your email.");
      setTimeout(() => navigate("/worker-reset-password"), 900);
    } catch (err) {
      console.error(err);
      setMessage("Unable to send reset code.");
    }
  };

  return (
    <div className="min-h-screen bg-white px-6 py-12">
      <div className="max-w-md mx-auto space-y-6">

        {/* 🔥 BIG BYN LOGO */}
        <div className="flex justify-center">
          <img
            src={bynLogo}
            alt="Book Your Need"
            className="w-44 h-44 object-contain"
          />
        </div>

        <form onSubmit={handleSendOTP} className="space-y-4">
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 rounded-full border border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />

          <button
            type="submit"
            className="w-full py-3 rounded-full font-semibold text-white bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 hover:opacity-90 active:scale-95 transition"
          >
            Send reset code
          </button>
        </form>

        <button
          onClick={() => navigate("/worker-login")}
          className="w-full text-sm text-gray-500 hover:underline text-center"
        >
          Back to login
        </button>

        {message && (
          <p className="text-sm text-red-500 text-center">{message}</p>
        )}
      </div>
    </div>
  );
};

export default WorkerForgotPassword;
